import { MARQUEE_ITEMS } from "./data/content";

const Wordmark = ({ text, i }) => (
  <span className="mx-8 flex items-center gap-8" aria-hidden={i > 0}>
    <span
      className={`whitespace-nowrap text-2xl ${
        i % 3 === 0
          ? "font-display font-extrabold tracking-tight text-slate-400"
          : i % 3 === 1
          ? "font-mono font-medium tracking-[0.15em] text-slate-500 uppercase"
          : "font-sans font-light italic text-slate-400"
      }`}
    >
      {text}
    </span>
    <span className="h-1.5 w-1.5 rounded-full bg-gold/60" aria-hidden="true" />
  </span>
);

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section id="platform" className="border-y border-white/10 bg-surface/60 py-12 sm:py-14">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="text-center font-display text-2xl font-bold tracking-tight text-white sm:text-3xl" data-testid="marquee-heading">
          Different brands. One powerful support platform.
        </h2>
        <p className="mt-3 text-center text-sm text-slate-500">
          Independently branded agencies run on Agency HQ — powered by the industry&rsquo;s core systems.
        </p>
      </div>
      <div className="relative mt-9 overflow-hidden" data-testid="tech-marquee-wrapper">
        <div className="marquee-track">
          {items.map((t, i) => (
            <Wordmark key={`${t}-${i}`} text={t} i={i} />
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" aria-hidden="true" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" aria-hidden="true" />
      </div>
    </section>
  );
};

export default Marquee;
